import { IOfferInfo } from '../../models/realtorOffer';
import { TRealtor } from '../../models/realtor';
import { plural } from '@cian/utils';

export const getOffersCount = (offers: IOfferInfo[]) => {
  return offers.reduce((acc, curr) => acc + Number(curr.count), 0);
};

export const getCounters = ({
  experience,
  age,
  offers,
}: {
  experience: TRealtor['experience'];
  age: TRealtor['age'];
  offers: IOfferInfo[];
}) => {
  const offersCount = getOffersCount(offers);

  return [
    { label: 'Опыт работы', text: experience ?? 'не указан' },
    { label: 'На Циан', text: age },
    {
      label: 'В работе',
      text:
        offersCount > 0 ? `${offersCount} ${plural(offersCount, ['объект', 'объекта', 'объектов'])}` : 'нет объектов',
    },
  ];
};
